module.exports = __webpack_public_path__ + "img/20250813SelmaFynn-74.7f768576.jpg";